import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  "fill-opacity": ".9",
  d: "M3 12a9 9 0 0 1 15.84-5.85 1 1 0 0 0 1.52-1.3A10.98 10.98 0 0 0 12 1C5.925 1 1 5.925 1 12q0 .84.123 1.649A1 1 0 0 0 3.1 13.35 9 9 0 0 1 3 12"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  "fill-opacity": ".9",
  "fill-rule": "evenodd",
  d: "M3.313 18.75a7 7 0 0 1-.938-.024c-.762-.075-1.74-.34-2.157-1.233a1 1 0 0 1 1.787-.895c.036.023.176.1.564.137.565.056 1.39-.004 2.447-.209 2.096-.405 4.878-1.337 7.83-2.713 2.95-1.376 5.453-2.908 7.111-4.252.836-.678 1.412-1.272 1.733-1.74.22-.322.252-.478.258-.52a1 1 0 0 1 1.834-.794c.417.894-.01 1.813-.442 2.445a7 7 0 0 1-.59.737 1 1 0 0 1 .03.112c.144.711.22 1.447.22 2.199 0 6.075-4.925 11-11 11a10.98 10.98 0 0 1-8.687-4.25m17.66-7.442c-1.807 1.421-4.361 2.955-7.283 4.318-2.921 1.362-5.738 2.331-7.989 2.802A8.97 8.97 0 0 0 12 21a9 9 0 0 0 8.974-9.692",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#CF0",
  "fill-rule": "evenodd",
  d: "M13.035 8.136a4 4 0 0 0-4.899 2.829 1 1 0 0 1-1.932-.518 6 6 0 0 1 7.349-4.243 1 1 0 0 1-.518 1.932",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }